import React, { useEffect, useState } from 'react';
import { Truck } from 'lucide-react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import logo from '../../assets/cvj.png';
import './Header.css';

const Header = ({ setShowQuoteForm, user, setShowLogin }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 50);
  };

  const handleLogout = async () => {
    await signOut(auth);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const toggleQuoteForm = () => {
    setShowQuoteForm((prev) => !prev);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`header navbar sticky-top ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <button
          className="navbar-toggler d-lg-none"
          type="button"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <a className="navbar-brand" href="#">
          <img alt="CVJ Services Ltd Logo" className="header-logo" src={logo} />
        </a>

        {/* Desktop Navigation */}
        <div className="header-nav d-none d-lg-flex">
          <ul className="header-nav-list">
            {[
              { text: 'Home', href: '#', active: true },
              { text: 'Our Services', href: '/services.html' },
              { text: 'Fleet', href: '/fleet.html' },
              { text: 'About Us', href: '/about.html' },
              { text: 'Contact', href: '/contact.html' },
            ].map((item, index) => (
              <li key={index} className="header-nav-item">
                <a className={`header-nav-link ${item.active ? 'active' : ''}`} href={item.href}>
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <button className="header-cart-btn position-relative">
          <Truck size={24} />
          <span className="header-cart-badge position-absolute top-0 start-100 translate-middle">
            Quote
          </span>
        </button>

        {/* Traditional Mobile Menu (Visible when toggled) */}
        {isMenuOpen && (
          <div className="header-mobile-menu d-lg-none">
            <ul className="header-nav-list">
              {[
                { text: 'Home', href: '#', active: true },
                { text: 'Our Services', href: '/services.html' },
                { text: 'Fleet', href: '/fleet.html' },
                { text: 'About Us', href: '/about.html' },
                { text: 'Contact', href: '/contact.html' },
              ].map((item, index) => (
                <li key={index} className="header-nav-item" onClick={toggleMenu}>
                  <a className={`header-nav-link ${item.active ? 'active' : ''}`} href={item.href}>
                    {item.text}
                  </a>
                </li>
              ))}
              {user ? (
                <>
                  <li className="header-nav-item" onClick={toggleMenu}>
                    <button onClick={handleLogout} className="header-nav-link btn btn-link">
                      Logout
                    </button>
                  </li>
                  <li className="header-nav-item">
                    <span className="header-nav-link">{user.email}</span>
                  </li>
                </>
              ) : (
                <li className="header-nav-item" onClick={toggleMenu}>
                  <button
                    className="header-nav-link btn btn-link"
                    onClick={() => setShowLogin(true)}
                  >
                    Login
                  </button>
                </li>
              )}
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;